import React from 'react';
import PropTypes from 'prop-types';

import TotalAmount from '../component/totalAmount';
import Tax from '../component/tax';
import Product from './product';
import { getFlowType, getAPPID, isWHW, enableSelfSetup, checkIsMidnight, isWHWP2 } from '../../../Helpers/index';
import { getProductRefData } from '../../../../../utils/plansReference';
import { Body } from '../../../Typography';

const DueMonthly = ({ cartDetails, plansReferenceData, isCartPageView, taxFeeText, promotext, disneyPromoHelperText }) => {
  const flowType = getFlowType();
  const isWHWFlow = isWHW();

  const { dueMonthlyList = {}, dueMonthlyTaxes = {}, orderDetailsView = {} } = cartDetails || {};
  const plansReferenceDetails = plansReferenceData || {};
  const {
    titleForShowNbsLTE,
    titleForShowNbs5G,
    nbsDisclaimerMonthlyLTE,
    nbsDisclaimerMonthly5G,
    WHWDueMontnly,
    nbsDisclaimerMonthlyLTEMidnight,
    nbsDisclaimerMonthly5GMidnight,
  } = (plansReferenceDetails && plansReferenceDetails.miniCart) || {};

  let nbsDisclaimerMonthly = '';
  let titleForShowLabel = '';
  if (getAPPID() === 'AAL') {
    if (flowType === 'LTE') {
      titleForShowLabel = titleForShowNbsLTE;
      nbsDisclaimerMonthly = checkIsMidnight() ? nbsDisclaimerMonthlyLTEMidnight : nbsDisclaimerMonthlyLTE;
    } else if (isWHWFlow || isWHWP2()) {
      titleForShowLabel = WHWDueMontnly;
    } else {
      titleForShowLabel = enableSelfSetup() ? titleForShowNbs5G : WHWDueMontnly;
      nbsDisclaimerMonthly = checkIsMidnight() ? nbsDisclaimerMonthly5GMidnight : nbsDisclaimerMonthly5G;
    }
  }
  const planInfo = getProductRefData('dueMonthlyTaxForRedesign', 'dueMonthlyTaxForRedesign', plansReferenceDetails);
  return (
    <div className="mobiledueMonthlyWrapper  width100 pad14 onlyTopPad">
      {!isCartPageView ? (
        <>
          {orderDetailsView && (
            <TotalAmount
              showDueMonthly="true"
              totalDueMonthlyAmount={orderDetailsView?.dueMonthlyAmount || 0.0}
              dueMontlyLabel={titleForShowLabel || 'Due monthly'}
              dueMonthlyList={dueMonthlyList}
            />
          )}

          {dueMonthlyList && !isWHWFlow && (
            <Product
              showDueMonthly
              dueMonthlyList={dueMonthlyList}
              planInfo={planInfo}
              isMobileCart
              plansReferenceData={plansReferenceData}
              taxFeeText={taxFeeText}
              disneyPromoHelperText={disneyPromoHelperText}
              promotext={promotext}
            />
          )}
          {dueMonthlyTaxes && dueMonthlyList && dueMonthlyTaxes.length > 0 && (
            <Tax showDueMonthly="true" dueMonthlyTaxes={dueMonthlyTaxes?.[0]?.dueAmount} dueMonthlyList={dueMonthlyList} planInfo={planInfo} />
          )}
          {getAPPID() === 'AAL' && enableSelfSetup() && (
            <div className="textAlignLeft pad15 onlyTopPad">
              <Body size="small">{nbsDisclaimerMonthly}</Body>
            </div>
          )}
        </>
      ) : (
        getAPPID() === 'AAL' && <div className="">{/* <BillBreakdown/> */}</div>
      )}
    </div>
  );
};

DueMonthly.propTypes = {
  cartDetails: PropTypes.object,
  plansReferenceData: PropTypes.object,
  isCartPageView: PropTypes.bool,
  taxFeeText: PropTypes.string,
  promotext: PropTypes.string,
  disneyPromoHelperText: PropTypes.string,
};
export default DueMonthly;
